export default __webpack_public_path__ + "static/media/smile.5db2274c.svg";